import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {
  DatabaseItemLayoutType,
} from '@toolify/client/src/modules/databases/enum/DatabaseItemLayoutType'
import {getCanShowDatabaseItemLayerInSidebar} from '@toolify/client/src/modules/databases/functions/getCanShowDatabaseItemLayerInSidebar'
import {getDatabaseItemRouteSource} from '@toolify/client/src/modules/databases/functions/getDatabaseItemRouteSource'
import {IDatabaseItemRouteSource} from '@toolify/client/src/modules/databases/types/IDatabaseItemRouteSource'

interface IRouteLocationLike {
  name?: unknown
  fullPath?: string
  params: Record<string, unknown>
  query: Record<string, unknown>
  meta?: Record<string | number | symbol, unknown>
}

interface IGetIsDatabaseItemSidebarNavigationParams {
  to: IRouteLocationLike
  from: IRouteLocationLike
  baseRoute: IRouteLocationLike | null | undefined
  layerCount: number
  isSmallScreen: boolean
  getLayout: (source: IDatabaseItemRouteSource) => DatabaseItemLayoutType
}

// Whether a navigation only moves an item's address while the database page shows that item in its sidebar: opening
// it there, stepping to another item, or closing it. The page itself stays where it is.
export function getIsDatabaseItemSidebarNavigation({
  to,
  from,
  baseRoute,
  layerCount,
  isSmallScreen,
  getLayout,
}: IGetIsDatabaseItemSidebarNavigationParams): boolean {
  const isShownInSidebar = (layerRoute: IRouteLocationLike, targetLayerCount: number) => {
    return getCanShowDatabaseItemLayerInSidebar({
      layerRoute,
      baseRoute,
      layerCount: targetLayerCount,
      isSmallScreen,
    }) && getLayout(getDatabaseItemRouteSource(layerRoute)) === DatabaseItemLayoutType.Sidebar
  }
  if(to.name === RouteName.DatabaseItem) {
    // Stepping to another item swaps the open layer; opening one adds it.
    const isLayerKept = from.name === RouteName.DatabaseItem || Boolean(from.meta?.isFilePreview)
    const targetLayerCount = isLayerKept ? layerCount : layerCount + 1
    return isShownInSidebar(to, targetLayerCount)
  }
  return from.name === RouteName.DatabaseItem
    && isShownInSidebar(from, layerCount)
    && Boolean(baseRoute?.fullPath)
    && to.fullPath === baseRoute.fullPath
}
